import React from "react";
import type {VoidFunctionComponent} from "react";
import {useFilterGenreDropdownMenuLogic} from "./FilterGenreDropdownMenu.logic";
import {DropdownFilterMenu} from "../../filters/dropdown-filter-menu/DropdownFilterMenu";
import {FilterGenres} from "../filter-genres/FilterGenres";

export const FilterGenreDropdownMenu: VoidFunctionComponent = () => {
  const {label, onClickMenuToggleHandler, isActive, isAvailable, dropdownFilterMenuRef} = useFilterGenreDropdownMenuLogic();
  if (!isAvailable){
    // not available
    return null;
  }
  return <DropdownFilterMenu
    ref={dropdownFilterMenuRef}
    {...{label, onClickMenuToggleHandler, isActive}}
    component={FilterGenres}
  />;
}
